var _effectorFileName = "/builds/gmini/front-ui-kit/src/icons/ArrowRight.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
export const ArrowRight = ({
  color = '#79AFFF',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsx("path", {
    d: "M8.89053 2.72943C8.56957 2.28187 7.9471 2.17818 7.49839 2.49751C7.04703 2.81872 6.94292 3.44572 7.26625 3.89557L8.06 4.99992H2C1.44772 4.99992 1 5.44764 1 5.99992C1 6.55221 1.44772 6.99992 2 6.99992H8.06L7.27156 8.10488C6.95049 8.55485 7.05585 9.18028 7.50622 9.50079C7.95564 9.82062 8.57961 9.71646 8.90023 9.2676L10.82 6.57992C11.07 6.22992 11.07 5.76992 10.82 5.41992L8.89053 2.72943Z",
    fill: color
  })
});